import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetGroupMetaDataServiceConfig = {
  name: "AssetGroupMetaData",
  annotations: []
} as ServiceConfig;